// Angular
import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnInit
} from '@angular/core';

// Local library
import { WagerFacade } from '@amwager/wager/data-access';
import { CommonModule } from '@angular/common';
import { dutchAmounts, dutchWagersService, ticketRequest } from '@amwager/util-ts';
import { FundingComponent } from '@amwager/funding/feature-ion';

// Ionic
import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonTitle,
  IonContent,
  IonItem,
  IonGrid,
  IonRow,
  IonCol,
  ModalController,
  NavParams,
  AlertController
} from '@ionic/angular/standalone';

// Third party
import _ from 'lodash';

@Component({
  selector: 'feature-ion-amwager3-dutch',
  templateUrl: './dutch.component.html',
  styleUrls: ['./dutch.component.scss'],
  imports: [
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonTitle,
    IonContent,
    IonItem,
    IonGrid,
    IonRow,
    IonCol,
    CommonModule
  ],
  standalone: true
})
export class DutchComponent implements OnInit {

  eventName!: any;
  dutchTicket!: any;
  dutchTicketCopy!: any;
  poolMatrix!: any;
  totalCost!: any;
  baseAmount!: any;
  balanceAmount!: any;
  pool!: any;
  modifier!: any;
  selectedRunners!: any;

  // for dynamic total cost & others
  dutchEnum!: any;
  runnersEnmList!: any;
  defaultModifier!: any;
  events!: any;
  selectedRace!: any;
  selectedEvent!: any;
  maxWagerTotal!: any;
  isBlockJurisdiction!: any;
  isBlockJurisdictionMsg!: any;

  dutchHolder!: any;
  dutchAmountHolder!: any;
  minPayout!: any;
  maxPayout!: any;

  toRemoveTickets!: any;

  constructor(
    private readonly alertCtrl: AlertController,
    private readonly modalCtrl: ModalController,
    private readonly navParams: NavParams,
    private readonly wagerFacade: WagerFacade,
    private readonly cdRef: ChangeDetectorRef,
    private readonly ngZone: NgZone
  ) {

    this.wagerFacade.getRaceMatrix$()
      .subscribe((callback) => {

        if (callback === undefined) return;

        this.poolMatrix = callback[this.pool?.PoolId]?.response?.ToteResponse;

        if (
          this.eventName &&
          this.dutchTicket &&
          this.dutchTicketCopy &&
          this.poolMatrix &&
          this.baseAmount &&
          this.pool &&
          this.modifier &&
          this.selectedRunners
        )
          this.initBetRows();

        this.cdRef.markForCheck();
      });
  }

  ngOnInit() {
    this.eventName = this.navParams.get('eventName');
    this.dutchTicket = this.navParams.get('dutchTicket');
    this.dutchTicketCopy = _.clone(this.dutchTicket);
    this.poolMatrix = this.navParams.get('poolMatrix');
    this.baseAmount = this.navParams.get('baseAmount');
    this.totalCost = this.navParams.get('totalCost');
    this.pool = this.navParams.get('pool');
    this.modifier = this.navParams.get('modifier');
    this.selectedRunners = this.navParams.get('selectedRunners');

    // for dynamic total cost & others
    this.dutchEnum = this.navParams.get('dutchEnum');
    this.runnersEnmList = this.navParams.get('runnersEnmList');
    this.defaultModifier = this.navParams.get('defaultModifier');
    this.events = this.navParams.get('events');
    this.selectedRace = this.navParams.get('selectedRace');
    this.selectedEvent = this.navParams.get('selectedEvent');
    this.maxWagerTotal = this.navParams.get('maxWagerTotal');
    this.isBlockJurisdiction = this.navParams.get('isBlockJurisdiction');
    this.isBlockJurisdictionMsg = this.navParams.get('isBlockJurisdictionMsg');

    this.toRemoveTickets = [];
    this.initBetRows();
  }

  initBetRows(): void {

    this.dutchTicket = new dutchWagersService().buildDutchWagers(
      this.dutchEnum,
      this.runnersEnmList,
      this.defaultModifier,
      this.pool,
      this.baseAmount,
      this.poolMatrix,
      this.events,
      this.selectedRace,
      this.selectedEvent,
      this.maxWagerTotal,
      this.isBlockJurisdiction,
      this.isBlockJurisdictionMsg,
      this.toRemoveTickets
    );

    const runners: any = [];
    for(let i=0; i < this.dutchTicket?.Wagers.length; i++){
      runners.push(this.dutchTicket?.Wagers[i].getRunnerList());
    }
    // const dutchHolder = new dutchAmounts(runners, this.pool, this.baseAmount);
    this.dutchHolder = new dutchAmounts(runners, this.pool, this.baseAmount);

    this.dutchHolder.initBaseParams(this.poolMatrix);

    if (this.dutchTicket?.DutchType == 1) {
      this.dutchAmountHolder = this.dutchHolder.calcAmountByBaseAmount(
        this.baseAmount, this.poolMatrix
      );
    }
    else
    {
      this.dutchAmountHolder = this.dutchHolder.calcAmountByBasePayout(
        this.baseAmount, this.poolMatrix
      );
    }

    this.dutchTicket.DutchProjections["ProjectedMaxROI"] = this.dutchHolder.calcROI(
      this.dutchHolder.MaxPayout
    );
    this.dutchTicket.DutchProjections["ProjectedMinROI"] = this.dutchHolder.calcROI(
      this.dutchHolder.MinPayout
    );

    this.minPayout = this.dutchHolder.calcROI(this.dutchHolder.MinPayout);
    this.maxPayout =  this.dutchHolder.calcROI(this.dutchHolder.MaxPayout);
    this.totalCost = this.dutchTicket.calcAmount();

    this.cdRef.markForCheck();
  }

  removeBet(id: any): void {

    if (id === undefined) return;

    let amountHolder!: any;
    this.dutchTicket.Wagers.splice(id, 1);

    this.dutchTicket = new ticketRequest(
      this.dutchTicket.RunId,
      this.dutchTicket.EventId,
      this.dutchTicket.RaceId,
      this.dutchTicket.Wagers,
      this.dutchTicket.DutchType,
      this.dutchTicket.DutchProjections
    );

    let comboToRemove = [];
    for(let ctr = 0; ctr < this.dutchHolder.RunnersByWager[id].length; ctr++ ){
      comboToRemove.push(this.dutchHolder.RunnersByWager[id][ctr][0]);
    }
    this.toRemoveTickets.push(comboToRemove);

    this.dutchHolder.RunnersByWager.splice(id, 1);
    this.dutchHolder.initBaseParams(this.poolMatrix);

    if(this.dutchTicket?.DutchType == 1)
    {
      amountHolder = this.dutchHolder.calcAmountByBaseAmount(this.baseAmount, this.poolMatrix);
    }
    else
    {
      amountHolder = this.dutchHolder.calcAmountByBasePayout(this.baseAmount, this.poolMatrix);
    }

    for(let i=0; i < this.dutchTicket.Wagers.length; i++) {
      this.dutchTicket.Wagers[i].BaseAmount = amountHolder[i][0];
    }

    this.initBetRows();
    this.cdRef.markForCheck();
  }

  submitAll(): void {
    if (this.dutchTicket.calcAmount() > this.balanceAmount) {
      this.showAlertInfo('Info', 'Insufficient Funds.', 'Deposit Now');
      return;
    }

    this.modalCtrl.dismiss({betType: 'bet-now', typeIs: 'dutch', dutchTicket: this.dutchTicket});
  }

  saveAll(): void {
    this.modalCtrl.dismiss({betType: 'save-bet', typeIs: 'dutch', dutchTicket: this.dutchTicket});
  }

  close() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  async openFunding(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: FundingComponent,
    });
    modal.present();
  }

  async showAlertInfo(hdr: string, msg: string, btn: string): Promise<void> {
    const alert = await this.alertCtrl.create({
      header: hdr,
      message: msg,
      buttons: [
        {
          text: btn,
          handler: () => {
            this.ngZone.run(()=>{
              this.modalCtrl.dismiss();
              this.openFunding();
            });
          }
        }
      ]
    });

    await alert.present();
  }

}
